'use client';

import cx from 'clsx';

import { useBuyerNonSuspense } from '~/api/domains';
import { shareECouponByKakao } from '~/app/common/libs/kakao';
import type { StyleableProps } from '~/types';
import type { Order, OrderGift } from '~/api/domains';

type Props = {
  gift?: OrderGift;
  encryptedOrderCode: Order['encryptedOrderCode'];
} & StyleableProps;

export function ECouponShareKakao({
  gift,
  encryptedOrderCode,
  className,
}: Props) {
  const { data: user } = useBuyerNonSuspense();
  const onClickShareKakao = () => {
    if (!encryptedOrderCode) return;
    shareECouponByKakao({
      receiverName: gift!.receiverName,
      name: user?.name || '',
      id: encryptedOrderCode,
      description: gift!.giftMessage,
    });
  };

  return (
    <button
      className={cx(
        'h-32 w-full rounded-12 bg-kakao typo-paragraph100-semibold',
        className,
      )}
      type="button"
      onClick={onClickShareKakao}
    >
      카카오톡으로 선물 공유하기
    </button>
  );
}
